import { IListFetcher } from '~src/httpClient/fetchers/IListFetcher';
import { ListResult } from '~src/httpClient/fetchers/ListResult';
import { formatFilterClauses, getPage } from '~src/httpClient/resources/ResourceQuery';
import { IFieldValue } from '~src/httpClient/serverApi/types/IFieldValue';
import { FieldValueResourceType } from '~src/httpClient/serverApi/types/IFieldValuesParams';
import { IArchivedFieldValuesParams } from '~src/recycleBin/serverApi/requests/GetArchivedFieldValuesRequest';
import { ILeafFilterClause } from '~src/spacesPlatform/models/IFilterClause';

export class ArchivedFieldValuesQuery {

  private filterClauses: ILeafFilterClause[];
  private matchText: string;

  constructor(
    private fetcher: IListFetcher<IFieldValue>,
    private field: string,
    private contentType?: FieldValueResourceType,
  ) { }

  // Getters

  public getSlice(start: number, size: number): Promise<ListResult<IFieldValue>> {
    const params: IArchivedFieldValuesParams = {
      field: this.field,
      labelMatchText: this.matchText,
      page: getPage(start, size),

      contentType: this.contentType,
      resourceCountFilter: formatFilterClauses(this.filterClauses),
    };

    return this.fetcher.fetchList(params);
  }

  public getFilters(): ILeafFilterClause[] {
    return this.filterClauses;
  }

  // Public Clone and Setters

  public withMatchText(matchText: string): ArchivedFieldValuesQuery {
    return this.clone().setMatchText(matchText);
  }

  public withFilters(filterClauses: ILeafFilterClause[]): ArchivedFieldValuesQuery {
    return this.clone().setFilterClauses(filterClauses);
  }

  // Private methods

  private clone(): ArchivedFieldValuesQuery {
    return new ArchivedFieldValuesQuery(this.fetcher, this.field, this.contentType)
      .setFilterClauses(this.filterClauses)
      .setMatchText(this.matchText);
  }

  private setFilterClauses(filterClauses: ILeafFilterClause[]): ArchivedFieldValuesQuery {
    this.filterClauses = filterClauses;
    return this;
  }

  private setMatchText(matchText: string): ArchivedFieldValuesQuery {
    this.matchText = matchText;
    return this;
  }

}
